
<div class="action modal-footer">
  <div class="action-area text-right col-md-12">
    <button *ngIf="!hideDefaultAction" class="btn btn-light" (click)="Cancel()" tooltip="{{ 'Common.Close' | translate }}">{{'Common.Close'|translate}} </button>
    <button *ngIf="!hideDefaultAction" class="btn btn-success" (click)="Save()" tooltip="{{ 'Common.Save' | translate }}">{{ 'Common.Save' | translate }} </button>
    <!--<button [hidden]="hideDefaultAction" class="btn btn-success pull-right mb-4 mr-3" (click)="Save()">{{ 'Common.Save' | translate }} </button>
  <button [hidden]="hideDefaultAction" class="btn btn-default pull-right mb-4 mr-3" (click)="common.NavigateToRoute(common.RouteUrls.Agencies.List)">{{'Common.Close'|translate}} </button>-->
    <ng-content select="action-extender"></ng-content>
  </div>
</div>


